import { Pipe, PipeTransform } from '@angular/core';
import { DuplicationType } from 'src/app/api/models';

@Pipe({
  name: 'duplication',
})
export class DuplicationPipe implements PipeTransform {
  transform(value: DuplicationType): string {
    return duplicationTransform(value);
  }
}

export const duplicationTransform = (value: DuplicationType): string => {
  switch (value) {
    case DuplicationType.Add:
      return 'Aggiungi';
    case DuplicationType.Overwrite:
      return 'Sovrascrivi';
    case DuplicationType.Block:
      return 'Blocca';
    default:
      return '';
  }
};
